module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "coffee-view"
  }, [_c('img', {
    attrs: {
      "src": "static/img/coffee.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("If you like VUWE, you might bought me a cup of coffee, I'll keep working hard on it! Thank you!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-db8212b0!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/coffee.vue
// module id = 288
// module chunks = 0